// app/SetupContext.tsx — share setup-gate status across the app (fetch once).
import { createContext, useContext, type ReactNode } from 'react';
import { useSetup, type UseSetup } from '../hooks/useSetup';

const SetupContext = createContext<UseSetup | null>(null);

export function SetupProvider({ children }: { children: ReactNode }) {
  const setup = useSetup();
  return <SetupContext.Provider value={setup}>{children}</SetupContext.Provider>;
}

export function useSetupContext(): UseSetup {
  const ctx = useContext(SetupContext);
  if (!ctx) throw new Error('useSetupContext must be used within <SetupProvider>');
  return ctx;
}
